import Api from "repository/Api"
import groupNames from "text/groupNames.json";
import {CONVERTING_GET_TIMEOUT_MS} from "config";

export const getProject = async (projectId) => {
    const res = await Api.get(`/projects/${projectId}`);
    return res.data;
};

export const getStatus = async (projectId) => {
    const res = await Api.get(`/projects/${projectId}/status`);
    return res.data;
};

// calibration

// The one GET of the calibration: the file as uploaded, and the working file. A store_version 2 project answers an explicit null where it has no working file, a
// store_version 1 project leaves the key out, so both read as null. The id, which was the topic of a subscription that is gone, is not read.
export const getCalibration = async (projectId) => {
    const res = await Api.get(`/projects/${projectId}/calibration-data`);
    return {data: res.data.data, dataModified: res.data.dataModified ?? null};
};

//map packs

// A store_version 1 project answers a JSON-LD collection, a store_version 2 project a plain array (MapPacksAction).
export const getProjectMapPacks = async (projectId) => {
    const res = await Api.get(`/projects/${projectId}/map-packs`);
    return Array.isArray(res.data) ? res.data : res.data["hydra:member"];
};

// The client's fallbacks for the fields a folder can lack (R42). The sidebar lower-cases a folder's group and both descriptions on every keystroke
// of its search box, and the open flow sorts the folders by description, so none of them may be null.
const sanitiseFolder = folder => {
    // The API sends NOT_GROUPED for a folder that no folders CSV groups, and its contract allows null. Neither is a group the sidebar has, nor is
    // any other group that the whitelist lacks.
    let groupName = (folder.groupName ?? "NOT_GROUPED").toLowerCase();
    if (!groupNames.includes(groupName)) groupName = "ungrouped";

    return {
        ...folder,
        groupName,
        titleDescription: folder.titleDescription || folder.title,
        codeNames: folder.codeNames.map(map => ({...map, titleDescription: map.titleDescription ?? map.title})),
    };
};

/**
 * Retrieve the folder & map structure of one map pack of this project from the api.
 * The first read of a store_version 1 project converts it inside this request, so the request has a timeout of its own: it has to end before
 * nginx or Cloudflare cut the request off. The caller can pass another as {timeout}.
 */
export const getProjectMapPackFolders = async (projectId, pack, {timeout} = {}) => {
    const res = await Api.get(`/projects/${projectId}/maps?pack=${encodeURIComponent(pack)}`, {timeout: timeout ?? CONVERTING_GET_TIMEOUT_MS});
    return res.data.folders.map(sanitiseFolder);
};
